export type SupportProvider = 'כללית' | 'מכבי' | 'מאוחדת' | 'לאומית' | 'פרטי';
export type AttendanceStatus = 'Pending' | 'Confirmed' | 'Missed';

export interface WeekDay {
  id: string;
  label: string;
}

export const WEEK_DAYS: WeekDay[] = [
  { id: 'Sunday', label: 'ראשון' },
  { id: 'Monday', label: 'שני' },
  { id: 'Tuesday', label: 'שלישי' },
  { id: 'Wednesday', label: 'רביעי' },
  { id: 'Thursday', label: 'חמישי' },
  { id: 'Friday', label: 'שישי' },
  { id: 'Saturday', label: 'שבת' },
];
